import { createSlice } from "@reduxjs/toolkit";
import { getDownIndicator } from "../../services/policyholderService";
import { logger } from "../../logging";

const downIndicatorSlice = createSlice({
  name: "downIndicator",
  initialState: {
    gwIndicator: null,
    isLoading: false,
    error: null
  },
  reducers: {
    started: state => {
      state.isLoading = true;
      state.gwIndicator = null;
      state.error = false;
    },
    succeeded: (state, action) => {
      state.isLoading = false;
      state.gwIndicator = action.payload?.filter(
        _ => _.system === "GWS"
      )?.[0]?.status;
      state.error = false;
    },
    failed: state => {
      state.isLoading = false;
      state.gwIndicator = null;
      state.error = true;
    }
  }
});

export const fetchdownIndicatorInfo = () => dispatch => {
  const { started, succeeded, failed } = downIndicatorSlice.actions;
  const onError = e => {
    dispatch(failed());
    logger.error({
      description: e.toString(),
      fatal: true
    });
  };
  dispatch(started());
  return getDownIndicator("GWS").then(
    response => {
      if (response?.status === 200) dispatch(succeeded(response?.data));
      else onError(response);
    },
    error => onError(error)
  );
};

export default downIndicatorSlice.reducer;
